import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Scroll-triggered slide-in. Alternates left/right when `index` is provided.
export default function Reveal({ children, index = 0, direction, className = "", ...rest }) {
  const reduce = useReducedMotion();
  const dir = direction || (index % 2 === 0 ? "left" : "right");
  const offset = dir === "left" ? -60 : 60;
  if (reduce) return <div className={className} {...rest}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, x: offset }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
